
  <div class="wrapper-content event-header wow slideInDown"  *ngIf="cont"
  data-wow-delay="0.5s"
  style="margin-bottom: 20px;" >
    <div class="event-panel right">
      <div class="panel-box-top">
        <!-- <div class="cea-brand">
          <img src="{{api.getImageUrl(cont.image)}}" alt="">
        </div> -->
        <div class="event-description">
          <h4>{{cont.webcontext?.title.es}}</h4>
          <h1>{{cont.title?.es}}</h1>
          <p>{{cont.created_at}}</p>
         </div>
      </div>
    </div>

  </div>


  <app-widgets *ngIf="cont" [data]="cont"></app-widgets>
  <app-footer></app-footer>



